import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import VendorLiveTracking from '../components/VendorLiveTracking';

export default function VendorTracking() {
  const { serviceId } = useParams();
  const [searchParams] = useSearchParams();
  const isIframe = searchParams.get('iframe') === 'true';
  const polyline = searchParams.get('polyline');
  


  // If loaded in iframe, render a simpler version without full page styling
  if (isIframe) {
    return (
      <div style={{ padding: '10px', height: '100vh', overflow: 'hidden' }}>
        <VendorLiveTracking 
          serviceId={serviceId} 
          isIframe={true} 
          polyline={polyline}
        />
      </div>
    );
  }

  // Normal full page rendering
  return (
    <div>
      <VendorLiveTracking 
        serviceId={serviceId} 
        isIframe={false} 
        polyline={polyline}
      />
    </div>
  );
} 